export const moveTo = (x, y) => `M${x},${y}`

export const lineTo = (x, y) => `L${x},${y}`

export const quadraticTo = (cx, cy, x, y) => `Q${cx},${cy} ${x},${y}`
